"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLeaseToOwnData = exports.LeaseToOwnDataContextProvider = exports.LeaseToOwnDataContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LeaseToOwnDataContext = exports.LeaseToOwnDataContext = /*#__PURE__*/_react.default.createContext();
const parseLeaseToOwnData = exactMatchDomain => {
  const leaseToOwnOptions = exactMatchDomain?.LeaseToOwnOptions;
  const paymentTerm = leaseToOwnOptions?.PaymentTerm;
  const maxPayments = leaseToOwnOptions?.MaxPayments;
  const minPayments = leaseToOwnOptions?.MinPayments;
  const defaultPayments = leaseToOwnOptions?.DefaultPayments;
  const installmentLengthAndPrices = leaseToOwnOptions?.PaymentOptions.reduce((paymentOptions, option) => {
    paymentOptions[option.NumPayments] = option.PaymentPriceDisplay;
    return paymentOptions;
  }, {});
  return {
    paymentTerm,
    installmentLengthAndPrices,
    maxPayments,
    minPayments,
    defaultPayments
  };
};
exports.parseLeaseToOwnData = parseLeaseToOwnData;
const LeaseToOwnDataContextProvider = ({
  children,
  availableDomain,
  leaseToOwnFeatureData,
  ltoInCart = {},
  ...props
}) => {
  const {
    paymentTerm,
    installmentLengthAndPrices,
    maxPayments,
    minPayments,
    defaultPayments
  } = parseLeaseToOwnData(availableDomain);
  const {
    defaultTermLengthOverride
  } = leaseToOwnFeatureData?.data || {};
  const defaultTermLength = ltoInCart.paymentTerm || defaultPayments;
  const termLength = installmentLengthAndPrices[defaultTermLengthOverride] ? defaultTermLengthOverride : defaultTermLength;
  const defaultPaymentsPrice = installmentLengthAndPrices[termLength];
  const [numPayments, setNumPayments] = (0, _react.useState)(termLength);
  const [paymentPrice, setPaymentPrice] = (0, _react.useState)(defaultPaymentsPrice);
  return /*#__PURE__*/_react.default.createElement(LeaseToOwnDataContext.Provider, {
    value: {
      numPayments,
      setNumPayments,
      paymentTerm,
      minPayments,
      maxPayments,
      paymentPrice,
      setPaymentPrice,
      installmentLengthAndPrices,
      ltoInCart
    }
  }, /*#__PURE__*/_react.default.cloneElement(children, {
    availableDomain,
    leaseToOwnFeatureData,
    ...props
  }));
};
exports.LeaseToOwnDataContextProvider = LeaseToOwnDataContextProvider;
LeaseToOwnDataContextProvider.propTypes = {
  children: _propTypes.default.node,
  availableDomain: _propTypes.default.object,
  leaseToOwnFeatureData: _propTypes.default.shape({
    data: _propTypes.default.shape({
      learnMoreText: _propTypes.default.string,
      tooltipContent: _propTypes.default.string,
      serviceFees: _propTypes.default.arrayOf(_propTypes.default.shape({
        minValueRange: _propTypes.default.number,
        maxValueRange: _propTypes.default.number,
        percentage: _propTypes.default.number
      })),
      defaultTermLengthOverride: _propTypes.default.number
    })
  }),
  ltoInCart: _propTypes.default.shape({
    paymentTerm: _propTypes.default.number
  })
};